<template>
  <genetic-nav current="history">
    <template #mainContent>
      <a-page-header
          style="border: 1px solid rgb(235, 237, 240)"
          :title="$t('taskList')"
      >
        <task-search @changeSearch="changeSearch"></task-search>
      </a-page-header>
      <v-page :total="page.total" :order-list="orderList" @pageChange="changePage" ></v-page>
      <a-table :columns="cols" :data-source="taskList" :pagination="false">
        <template #bodyCell="{ column, record, index }">
          <template v-if="column.key === 'index'">
            {{ index + 1 }}
          </template>
          <template v-if="column.key === 'animaltype'">
            <option-tag :option-list="animalTypeList" :option-val="record.animaltype"></option-tag>
          </template>
          <template v-if="column.key === 'edittype'">
            <option-tag :option-list="editTypeList" :option-val="record.edittype"></option-tag>
            <a-tag color="#108ee9" v-if="record.edittype === '07'">{{ record.otheredit }}</a-tag>
          </template>
          <template v-if="column.key === 'belonguser'">
            {{ record.userName }}
          </template>
          <template v-if="column.key === 'createtime'">
            {{ formatDate(record.createtime) }}
          </template>
          <template v-if="column.key === 'description'">
            <div style="word-break: break-all">
              {{ record.description }}
            </div>
          </template>
          <template v-if="column.key === 'status'">
            <!--            <option-tag :option-list="statusList" :option-val="record.status"></option-tag>-->
            <a-tag color="#f50" v-if="record.completestatus === '91'">{{ $t("quit") }}</a-tag>
            <a-tag color="#2db7f5" v-else-if="record.status === '08'">{{ $t("hasComplete") }}</a-tag>
            <option-tag v-else :option-list="statusList" :option-val="record.status"></option-tag>
          </template>
          <template v-if="column.key === 'operation'">
            <task-detail :task-id="record.id" @changeStatus="initPage"></task-detail>
          </template>
        </template>
      </a-table>
    </template>
  </genetic-nav>
</template>+

<script>
import GeneticNav from "@/components/public/geneticNav.vue";
import TaskSearch from "@/components/task/taskSearch.vue";
import VPage from "@/components/public/v-page.vue";
import util from "@/util/util";
import TaskDetail from "@/components/task/taskDetail.vue";
import OptionTag from "@/components/public/optionTag.vue";

export default {
  name: "recordHistory",
  components: {OptionTag, TaskDetail, VPage, TaskSearch, GeneticNav},
  data() {
    return {
      taskList: [],
      searchFlag:"reset",
      page: {
        current: 1,
        total: 0,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '50', '100', '500', '99999'],
        sortType: "back",
        order: "",
      },
      search: {}
    }
  },
  mounted() {
    this.initPage();
  },
  methods: {
    changeSearch(search, type) {
      this.search = search;
      this.page.current = 1;
      this.page.pageSize = 10;
      this.searchFlag = type;
      // this.initPage();
      if (this.searchFlag === "reset"){
        this.initPage();
      }else {
        this.searchAll();
      }
    },
    searchAll(){
      var post = {
        page: JSON.stringify(this.page),
        search: JSON.stringify(this.search)
      }
      util.$post("/task/list/searchAll", post, (res) => {
        this.taskList = res.taskList;
        this.page.total = res.total;
      }, this.showMask, this.hideMask);
    },
    initPage() {
      var post = {
        page: JSON.stringify(this.page),
        search: JSON.stringify(this.search)
      }
      util.$post("/history/list/initPage", post, (res) => {
        this.taskList = res.taskList;
        this.page.total = res.total;
      }, this.showMask, this.hideMask);
    },
    changePage(page) {
      this.page = page;
      if (this.searchFlag === "reset"){
        this.initPage();
      }else {
        this.searchAll();
      }
    },
    formatDate(val) {
      return util.dateFormat(val, "YYYY-MM-DD")
    },
  },
  computed: {
    orderList() {
      return [
        {key: "animaltype", name: this.$t("animalType")},
        {key: "genename", name: this.$t("geneName")},
        {key: "edittype", name: this.$t("editType")},
        {key: "status", name: this.$t("status")},
        {key: "createtime", name: this.$t("createTime")},
      ]
    },
    statusList() {
      return util.statusList()
    },
    editTypeList() {
      return util.editTypeList();
    },
    animalTypeList() {
      return util.animalTypeList();
    },
    cols() {
      var cols = new Array();

      cols.push({
        title: '#',
        dataIndex: 'index',
        key: 'index',
        width: 70
      })

      cols.push({
        title: this.$t("animalType"),
        dataIndex: 'animaltype',
        key: 'animaltype',
        width: "8%"
      })

      cols.push({
        title: this.$t("taskIndex"),
        dataIndex: 'taskindex',
        key: 'taskindex',
        width: "10%"
      })

      cols.push({
        title: this.$t("geneName"),
        dataIndex: 'genename',
        key: 'genename',
        width: "10%"
      })

      cols.push({
        title: this.$t("editType"),
        dataIndex: 'edittype',
        key: 'edittype',
        width: "10%"
      })

      cols.push({
        title: this.$t("description"),
        dataIndex: 'description',
        key: 'description',
      })

      cols.push({
        title: this.$t("belongUser"),
        dataIndex: 'belonguser',
        key: 'belonguser',
        width: "15%"
      })

      cols.push({
        title: this.$t("createTime"),
        dataIndex: 'createtime',
        key: 'createtime',
        width: "10%"
      })

      cols.push({
        title: this.$t("status"),
        dataIndex: 'status',
        key: 'status',
        width: "10%"
      })

      cols.push({
        title: this.$t("operation"),
        dataIndex: 'operation',
        key: 'operation',
        width: 70
      })
      return cols;
    }
  }
}
</script>

<style scoped>

</style>